import React, { useState } from "react";

function OffersTabs({ bestSellers = [], onSale = [] }) {
  const [visibleItems, setVisibleItems] = useState({
    bestSeller: 8,
    onSale: 8,
  });

  const loadMore = (tabType) => {
    setVisibleItems((prev) => ({
      ...prev,
      [tabType]: prev[tabType] + 8,
    }));
  };

  const getVisibleItems = (items, tabType) => {
    return items.slice(0, visibleItems[tabType]);
  };

  const hasMoreItems = (items, tabType) => {
    return visibleItems[tabType] < items.length;
  };
  return (
    <section className="flat-spacing-17">
      <div className="container">
        <div className="flat-animate-tab">
          <ul
            className="widget-tab-3 d-flex justify-content-center wow fadeInUp"
            data-wow-delay="0s"
            role="tablist"
          >
            <li className="nav-tab-item" role="presentation">
              <a href="#bestSeller" className="active" data-bs-toggle="tab">
                Best seller
              </a>
            </li>
            <li className="nav-tab-item" role="presentation">
              <a href="#onSale" data-bs-toggle="tab">
                On Sale
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div
              className="tab-pane active show"
              id="bestSeller"
              role="tabpanel"
            >
              <div className="grid-layout loadmore-item" data-grid="grid-4">
                {getVisibleItems(bestSellers, "bestSeller").map(
                  (product, index) => (
                    <div key={index} className="card-product fl-item2">
                      <div className="card-product-wrapper-edit">
                        <a
                          href={product.link || "/shop/default"}
                          className="product-img-edit"
                        >
                          <img src={product.image} alt={product.name} />
                        </a>
                      </div>
                      <div className="card-product-info">
                        <a
                          href={product.link || "/shop/default"}
                          className="title link"
                        >
                          {product.name}
                        </a>
                        {/* <span className="price">
                          {product.category || "Product"}
                        </span> */}
                      </div>
                    </div>
                  )
                )}
              </div>
              {hasMoreItems(bestSellers, "bestSeller") && (
                <div className="tf-pagination-wrap view-more-button text-center">
                  <button
                    className="tf-btn-loading tf-loading-default style-2 btn-loadmore"
                    onClick={() => loadMore("bestSeller")}
                  >
                    <span className="text">Load more</span>
                  </button>
                </div>
              )}
            </div>
            <div className="tab-pane" id="onSale" role="tabpanel">
              <div className="grid-layout loadmore-item3" data-grid="grid-4">
                {getVisibleItems(onSale, "onSale").map((product, index) => (
                  <div key={index} className="card-product fl-item2">
                    <div className="card-product-wrapper-edit">
                      <a
                        href={product.link || "/shop/default"}
                        className="product-img-edit"
                      >
                        <img src={product.image} alt={product.name} />
                      </a>
                    </div>
                    <div className="card-product-info">
                      <a
                        href={product.link || "/shop/default"}
                        className="title link"
                      >
                        {product.name}
                      </a>
                      <span className="price">
                        {product.category || "Product"}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {hasMoreItems(onSale, "onSale") && (
                <div className="tf-pagination-wrap view-more-button3 text-center">
                  <button
                    className="tf-btn-loading tf-loading-default style-2 btn-loadmore3"
                    onClick={() => loadMore("onSale")}
                  >
                    <span className="text">Load more</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OffersTabs;
